import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';
import { ActionTypes } from '../../utils/enums';

const TitleComponent = props => (
    <Title>
        {props.repsEmailed.length > 0 ? (
            props.repsEmailed.length > 1 ? (
                <Span>{copyFor('feedback', 'representatives', 'email')}</Span>
            ) : (
                <Span>
                    {copyFor('feedback', 'singleRecipient', 'email', undefined, {
                        recipientName: props.repsEmailed[0].fullName
                    })}
                </Span>
            )
        ) : (
            <Span>
                {copyFor('feedback', 'singleRecipient', 'email', undefined, {
                    recipientName: props.recipientMask
                })}
            </Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    recipientMask: PropTypes.string,
    repsEmailed: PropTypes.array
};

const EmailAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            rightAlign
            peopleCount={props.peopleCount}
            titleComponent={
                <TitleComponent
                    recipientMask={props.recipientMask}
                    repsEmailed={props.repsEmailed}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

EmailAction.propTypes = {
    recipientMask: PropTypes.string,
    repsEmailed: PropTypes.array,
    peopleCount: PropTypes.string.isRequired
};

export default connect(
    state => ({
        recipientMask: state.email.recipientMask,
        peopleCount:
            state.email.completeEmail !== undefined
                ? state.email.completeEmail.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : '',
        repsEmailed: state.email.successInfo.repsEmailed
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Email) return true;

            return next === prev;
        }
    }
)(EmailAction);
